import type { uuid } from "@/interfaces";
import { store } from "@/lib/store.ts";

export function activeOrganizationId(): uuid {
  const activeOrgId = store.getState().organization.activeOrgId;
  if (!activeOrgId) throw new Error("No active organization selected");
  return activeOrgId;
}

export const activeOrganizationIdIfAny = (): uuid | undefined => store.getState().organization.activeOrgId ?? undefined;
